import PropTypes from 'prop-types';

import './styles/panelGroupStyles.css';

const PanelGroup = ({ children }) => (
  <div className="mb-8 rounded panel-group">{children}</div>
);

PanelGroup.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PanelGroup;
